import * as z from 'zod'

import { ChangeMyPasswordVars } from '@/common/api/params/me'
import { NameLabelMapping } from '@/common/app/message'
import { PASSWORD_CAPTION, validatePassword } from '@/common/form/schema'

export { PASSWORD_CAPTION }

export const passwordSchema = z
  .object({
    currentPassword: z.string().min(1),
    newPassword: validatePassword(),
    confirmPassword: z.string().min(1)
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: '新しいパスワードと確認が一致しません',
    path: ['confirmPassword']
  })

export type PasswordFormSchemaType = z.infer<typeof passwordSchema>

export const convertPasswordSchemaToVars = (
  schema: PasswordFormSchemaType
): ChangeMyPasswordVars => ({
  current_password: schema.currentPassword,
  new_password: schema.newPassword
})

export const DEFAULT_PASSWORD_SCHEMA: PasswordFormSchemaType = {
  currentPassword: '',
  newPassword: '',
  confirmPassword: ''
}

export const passwordNameLabelMapping: NameLabelMapping = {
  currentPassword: '現在のパスワード',
  newPassword: '新しいパスワード',
  confirmPassword: '新しいパスワード（確認）'
}
